var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting (4) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 8.25049C9.92893 8.25049 8.25 9.92943 8.25 12.0005C8.25 14.0716 9.92893 15.7505 11.9999 15.7505C14.0711 15.7505 15.75 14.0716 15.75 12.0005C15.75 9.92943 14.0711 8.25049 11.9999 8.25049ZM9.75 12.0005C9.75 10.7579 10.7573 9.7505 11.9999 9.7505C13.2427 9.7505 14.2499 10.7579 14.2499 12.0005C14.2499 13.2432 13.2427 14.2505 11.9999 14.2505C10.7573 14.2505 9.75 13.2432 9.75 12.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4147 3.23279C14.4342 -0.202597 9.56564 -0.202596 8.58523 3.23279C8.28146 4.29719 7.18792 4.92855 6.11423 4.65942C2.6489 3.79079 0.214599 8.00713 2.69952 10.5739C3.46944 11.3692 3.46944 12.6319 2.69952 13.4271C0.214599 15.9939 2.6489 20.2102 6.11423 19.3416C7.18792 19.0725 8.28146 19.7038 8.58523 20.7682C9.56564 24.2036 14.4342 24.2036 15.4147 20.7682C15.7184 19.7038 16.812 19.0725 17.8857 19.3416C21.351 20.2102 23.7853 15.9939 21.3004 13.4271C20.5305 12.6319 20.5305 11.3692 21.3004 10.5739C23.7853 8.00713 21.351 3.79079 17.8857 4.65942C16.812 4.92855 15.7184 4.29719 15.4147 3.23279ZM10.0276 3.64443C10.5939 1.66019 13.406 1.66019 13.9722 3.64443C14.4982 5.48727 16.3915 6.58036 18.2504 6.1144C20.2519 5.61269 21.6579 8.04801 20.2227 9.53054C18.8897 10.9074 18.8897 13.0936 20.2227 14.4705C21.6579 15.953 20.2519 18.3883 18.2504 17.8866C16.3915 17.4207 14.4982 18.5138 13.9722 20.3566C13.406 22.3408 10.5939 22.3408 10.0276 20.3566C9.50172 18.5138 7.60843 17.4207 5.74952 17.8866C3.74798 18.3883 2.34196 15.953 3.77722 14.4705C5.1102 13.0936 5.1102 10.9074 3.77722 9.53054C2.34196 8.04801 3.74798 5.61269 5.74952 6.1144C7.60843 6.58036 9.50172 5.48727 10.0276 3.64443Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeSetting);
export default __webpack_public_path__ + "static/media/icon-stroke-setting.e88e215309f09d8bb5f8c07a99356fcc.svg";
export { ForwardRef as ReactComponent };